import { render, staticRenderFns } from "./NuevaSolicitud.vue?vue&type=template&id=4e9bbe84"
import script from "./NuevaSolicitud.vue?vue&type=script&lang=js"
export * from "./NuevaSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9bbe84')) {
      api.createRecord('4e9bbe84', component.options)
    } else {
      api.reload('4e9bbe84', component.options)
    }
    module.hot.accept("./NuevaSolicitud.vue?vue&type=template&id=4e9bbe84", function () {
      api.rerender('4e9bbe84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/NuevaSolicitud.vue"
export default component.exports